import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SessionData, userPaySlips } from '../../models/base/base';
import { branchesDto } from '../../models/admin/branch';

@Injectable({
  providedIn: 'root'
})
export class SessionWrapperService {
  private currentSessionSubject: BehaviorSubject<SessionData | any>;
  public currentSession: Observable<SessionData>;
  public menuKey$: Subject<boolean> = new Subject<boolean>();
  public currentDefaultBranchSubject$ = new BehaviorSubject<branchesDto | null>(this.getDefaultBranch());
  public DefaultBranchID;
  // public currentDefaultPaySlipSubject$ = new BehaviorSubject<userPaySlips | null>(this.getDefaultPaySlip());
  public currentDefaultPaySlipSubject$ = new BehaviorSubject<userPaySlips | null>(this.getDefaultPaySlip());
  public DefaultPaySlipID;

  private currentEmpIdSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(this.getEmpId());
  public currentEmpId$: Observable<string | null> = this.currentEmpIdSubject.asObservable();



  constructor() {
    this.currentSessionSubject = new BehaviorSubject(this.getsessionData()!);
    // this.currentDefaultBranchSubject$.subscribe(res => this.DefaultBranchID = res?.id);
    this.currentSession = this.currentSessionSubject.asObservable();
    this.currentDefaultBranchSubject$.subscribe(res => this.DefaultBranchID = res?.id);
    this.currentDefaultPaySlipSubject$.subscribe(res => this.DefaultPaySlipID = res?.id);
  }

  public get currentSessionValue(): SessionData {
    return this.currentSessionSubject.value;
  }

  getsessionData() {
    let session: SessionData = new SessionData();
    if (sessionStorage) {
      session.accesstoken = sessionStorage.getItem('access_token');
      let claims = JSON.parse(sessionStorage.getItem('id_token_claims_obj'));
      if (claims) {
        session.tenantid = claims['tenantid'];
        session.userid = claims['sub'];
      }
    }

    return session;
  }

  setDefaultBranch(branchdata) {
    if (branchdata) {
      localStorage.setItem('defaultBranchData', JSON.stringify(branchdata));
      this.currentDefaultBranchSubject$.next(branchdata);
    }
  }

  // getDefaultBranch() {
  //   let branchdata = JSON.parse(localStorage.getItem('defaultBranchData'));
  //   return branchdata;
  // }
  getDefaultBranch(): branchesDto | null {
    const branchdata = localStorage.getItem('defaultBranchData');

    if (!branchdata || branchdata === 'undefined' || branchdata === 'null') {
      return null;
    }

    try {
      return JSON.parse(branchdata) as branchesDto;
    } catch (e) {
      console.error('Invalid branch data in localStorage:', branchdata, e);
      return null;
    }
  }

  setDefaultPaySlip(payslip) {
    console.log("Setting default payslip:", payslip);
    if (payslip) {
      localStorage.setItem('defaultPaySlipData', JSON.stringify(payslip));
      this.currentDefaultPaySlipSubject$.next(payslip);
    }
  }

  // getDefaultPaySlip() {
  //    const payslipdata = localStorage.getItem('defaultPaySlipData');
  // return payslipdata ? JSON.parse(payslipdata) : null;
  //   // let payslipdata = JSON.parse(localStorage.getItem('defaultPaySlipData'));
  //   // return payslipdata;
  // }
  getDefaultPaySlip(): userPaySlips | null {
    const payslipdata = localStorage.getItem('defaultPaySlipData');
    if (!payslipdata || payslipdata === 'undefined' || payslipdata === 'null') {
      return null;
    }

    try {
      return JSON.parse(payslipdata) as userPaySlips;
    } catch (e) {
      console.error('Invalid payslip data in localStorage:', payslipdata, e);
      return null;
    }
  }

  setSysCode(syscode) {
    localStorage.setItem('sysCode', syscode);
  }

  getSysCode() {
    let syscode = localStorage.getItem('sysCode');
    return syscode;
  }

  clearSession() {
    localStorage.removeItem('defaultBranchData');
    localStorage.removeItem('defaultPaySlipData');
    localStorage.removeItem('sysCode');
  }

  setEmpId(empid: string) {
    sessionStorage.setItem('empId', empid);
  }

  setMenuKeyAndPageParameter(menukey: string, pageparameter: string): void {
    sessionStorage.setItem('pageParameter', pageparameter);
    sessionStorage.setItem('menuKey', menukey);
    this.menuKey$.next(true);
  }

  getPageParameter(): string {
    return sessionStorage.getItem('pageParameter');
  }

  getMenuKey(): string {
    return sessionStorage.getItem('menuKey');
  }

  getEmpId() {
    return sessionStorage.getItem('empId');
  }

  setUserName(username: string) {
    sessionStorage.setItem('userName', username);
  }
  getUserName() {
    return sessionStorage.getItem('userName');
  }

  //for exporting file name(en only)
  setPageName(pagename: string) {
    sessionStorage.setItem('pageName', pagename);
  }

  getPageName() {
    return sessionStorage.getItem('pageName');
  }

  //for pdf title(translated)
  setPageTitle(pagetitle: string) {
    sessionStorage.setItem('title', pagetitle);
  }

  getPageTitle() {
    return sessionStorage.getItem('title');
  }

  setCompanyName(companyname: string) {
    sessionStorage.setItem('companyName', companyname);
  }

  getCompanyName() {
    return sessionStorage.getItem('companyName');
  }


}
